// @flow
import React from "react";
import { get, noop } from "lodash";
import { LogoFDR } from "@fdr/static-ui/Logos";
import RadialLoader from "@fdr/static-ui/RadialLoader";
import LoginMessage from "../../_molecules/LoginMessage";
import { Container } from "./styled-components";
import { Container as FooterContainer } from "../../_molecules/LoginBox/styled-components";
import {
  FooterWrapper,
  HeaderWrapper,
  LogoWrapper
} from "../ErrorPage/styled-components";
import {
  PrimaryButton,
  SimpleLinkButton
} from "../../_atoms/Button/styled-components";

type Props = {
  isVisible: boolean,
  isError?: boolean,
  messages: {
    default: {
      title: string,
      subTitle: string
    },
    error: {
      title: string,
      subTitle: string,
      primaryButton: string,
      secondaryButton: string
    }
  },
  percent: number
};

const SplashLoadPage = ({ isVisible, isError, messages, percent }: Props) => (
  <Container
    id={isError ? "splash-load-error-screen" : "splash-load-screen"}
    data-qa-label="splash-load-screen"
    isVisible={isVisible}
  >
    <HeaderWrapper data-qa-label="splash-load-message-header">
      <LogoWrapper data-qa-label="splash-load-logo">
        {LogoFDR(30, "")}
      </LogoWrapper>
    </HeaderWrapper>
    {isError ? (
      <LoginMessage
        iconType="error"
        title={get(messages, "error.title", "")}
        Text={get(messages, "error.subTitle", "")}
        textType="text"
        qaLabel="splash-load"
      />
    ) : (
      <LoginMessage
        iconComponent={<RadialLoader width={144} percent={percent} />}
        title={get(messages, "default.title", "")}
        Text={get(messages, "default.subTitle", "")}
        textType="text"
        qaLabel="splash-load"
      />
    )}

    {isError && (
      <FooterWrapper>
        <FooterContainer>
          <PrimaryButton
            id="button-reload-app"
            isStretched
            data-qa-label="splashLoad-PrimaryButton"
          >
            {get(messages, "error.primaryButton", "")}
          </PrimaryButton>
          <SimpleLinkButton
            id="button-live-person"
            isStretched
            data-qa-label="splashLoad-SecondaryButton"
          >
            {get(messages, "error.secondaryButton", "")}
          </SimpleLinkButton>
        </FooterContainer>
      </FooterWrapper>
    )}
  </Container>
);

SplashLoadPage.defaultProps = {
  isVisible: false,
  isError: false,
  showBox: true,
  handlePrimaryButton: noop,
  handleSecondaryButton: noop,
  percent: 0
};

export default SplashLoadPage;
